<template>
  <!-- 品目一覧 -->
  <div id="AppMasterListProduct">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">品目一覧</label>
        </div>
      </div>
      <template :filterConditions="filterConditions">
        <div class="columns">
          <div class="column">
            <div class="field box is-floating-label">
              <label class="label">絞込条件</label>
              <div class="columns">
                <div class="column is-one-fifth">
                  <b-field label="品目コード" labelPosition="on-border">
                    <b-input v-model="filterConditions.productCode"></b-input>
                  </b-field>
                </div>

                <div class="column is-one-fifth">
                  <b-field label="品目名" labelPosition="on-border">
                    <b-input v-model="filterConditions.productName"></b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-button
                    style="float:right;"
                    class="button"
                    type="is-primary"
                    icon-right="filter"
                    native-type="button"
                    @click="filter()"
                  >絞り込み</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="columns">
        <div class="column">
          <b-field horizontal label="表示件数" style="float:right; white-space:nowrap;">
            <b-select position="is-right" v-model="perPage">
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div>
        <b-table
          :data="data"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :pagination-size="paginationSize"
          :default-sort-direction="defaultSortDirection"
          default-sort="category"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column
              field="productCode"
              label="品目コード"
              sortable
              centered
            >{{ props.row.productCode }}</b-table-column>
            <b-table-column field="productName" label="品目名" sortable>{{ props.row.productName }}</b-table-column>
            <b-table-column
              field="mrpAdminCode"
              label="MRP管理コード"
              sortable
              centered
            >{{ props.row.mrpAdminCode }}</b-table-column>
            <b-table-column
              field="mrpAdminName"
              label="MRP管理区分"
              sortable
            >{{ props.row.mrpAdminName }}</b-table-column>
            <b-table-column field="category" label="カテゴリ" sortable>{{ props.row.category }}</b-table-column>
            <b-table-column
              field="categoryName"
              label="カテゴリ名称"
              sortable
            >{{ props.row.categoryName }}</b-table-column>
            <b-table-column field="jancode" label="JANCODE" sortable>{{ props.row.jancode }}</b-table-column>
          </template>
        </b-table>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
var data = [];
export default {
  name: "AppMasterListProduct",
  methods: {
    filter: function() {
      var excuteApi = this.getProductListPOST;
      var successCallBack = this.getProductListSuccess;
      var errorCallBack = this.getProductListError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getProductListPOST: function(client) {
      return client.apis.apiMaster.getProductListPOST({
        body: {
          productCode: this.filterConditions.productCode,
          productName: this.filterConditions.productName
        }
      });
    },
    getProductListSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
    },
    getProductListError: function(result) {
      this.showErrorMessage(result);
    }
  },
  data() {
    return {
      data,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 100,
      filterConditions: {
        productCode: "",
        productName: ""
      }
    };
  },
  filters: {},
  components: {},
  mounted: function() {
    // WebApi Call
    this.filter(this.filterConditions);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppMasterListProduct.vue